"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var copyTextToClipBoard_1 = __importDefault(require("./functions/copyTextToClipBoard"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(0.25),
        cursor: 'pointer',
        opacity: 0.25,
        '&:hover': {
            backgroundColor: '#eee',
        }
    }
}); });
var CopyButton = function (_a) {
    var copyText = _a.copyText;
    var classes = useStyles();
    var handleCopy = react_1.useCallback(function () {
        copyTextToClipBoard_1.default(copyText);
    }, [copyText]);
    return (react_1.default.createElement(core_1.Box, { className: classes.root, onClick: handleCopy },
        react_1.default.createElement(icons_1.FileCopyOutlined, null)));
};
exports.default = CopyButton;
